import React from "react";
import styled from "styled-components";

const TextInputDiv = styled.div`
  .suffix {
    display: table-cell;
    padding: 6px 0;
  }

  &.nowrap {
    .text-input-label {
      white-space: nowrap;
    }
  }
`;

export const TextInputControlled = ({
  onChange,
  name,
  label = "Text",
  type = "text",
  disabled = false,
  className = "",
  placeholder = null,
  icon = undefined,
  autocomplete = "off",
  labelClassName = "",
  suffix = undefined,
  addon = undefined,
  nowrap = false,
  value = "",
  ...rest
}) => (
  <TextInputDiv
    className={`input-group ${className} ${nowrap ? "nowrap" : ""}`}
  >
    <span className="input-control-addon padding-0">
      {icon !== undefined ? (
        <div className="icon-label">
          <i className="material-icons">{icon}</i>
        </div>
      ) : null}
      {icon !== undefined ? (
        <div className={`text-input-label label-icon ${labelClassName}`}>
          {label}
        </div>
      ) : (
        <div className={`text-input-label no-class ${labelClassName}`}>
          {label}
        </div>
      )}
    </span>
    <div className="form-line">
      <input
        type={type}
        name={name}
        onChange={onChange}
        disabled={disabled}
        value={value}
        placeholder={placeholder}
        className="form-control"
        autoComplete={autocomplete}
        {...rest}
      />
      {suffix !== undefined && <span className="suffix">{suffix}</span>}
    </div>
    {(addon !== undefined && (
      <span className="input-group-addon">{addon}</span>
    )) ||
      null}
  </TextInputDiv>
);
